// @ts-nocheck

import React, { Component } from 'react'
import { colors } from '@lmc/common/constants'

export default class CurrentTodoSummary extends Component {
  render() {
    const { todoSummary } = this.props
    if (!todoSummary) return null

    const {
      text,
      icon: { url, color },
    } = todoSummary
    return (
      <div style={styles.container}>
        <div
          style={{
            ...styles.iconContainer,
            backgroundColor: color,
          }}
        >
          <img alt="" src={url} style={styles.icon} />
        </div>
        {text}
      </div>
    )
  }
}

const styles = {
  container: {
    color: colors.darkgrey,
    fontSize: 15,
    paddingTop: 8,
    letterSpacing: '0.8px',
    fontWeight: 300,
    textAlign: 'center',
  },
  icon: {
    width: 12,
    marginTop: 6,
  },
  iconContainer: {
    width: 30,
    height: 30,
    borderRadius: 4,
    margin: '0 auto 5px',
  },
}
